"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasPermissions = exports.hasPermissionsSync = exports.evaluateDynamicPermission = exports.evaluateDynamicPermissionOr = exports.hasStaticPermission = exports.hasStaticPermissionAnd = exports.hasStaticPermissionOr = exports.getPermissionsFromUserRoles = void 0;
const uniq_1 = __importDefault(require("lodash/uniq"));
const permissions_1 = require("./permissions");
const rolesWithPermissions_1 = require("./rolesWithPermissions");
function getPermissionsFromUserRoles(roles = []) {
    let allUserPermissions = [];
    for (const role of roles) {
        if (rolesWithPermissions_1.ROLES[role] && rolesWithPermissions_1.ROLES[role].length) {
            allUserPermissions = allUserPermissions.concat(rolesWithPermissions_1.ROLES[role]);
        }
    }
    return (0, uniq_1.default)(allUserPermissions);
}
exports.getPermissionsFromUserRoles = getPermissionsFromUserRoles;
function hasStaticPermissionOr(userPermissions, staticPermissions) {
    return staticPermissions.some((permission) => hasStaticPermission(userPermissions, permission));
}
exports.hasStaticPermissionOr = hasStaticPermissionOr;
function hasStaticPermissionAnd(userPermissions, staticPermissions) {
    return staticPermissions.every((permission) => hasStaticPermission(userPermissions, permission));
}
exports.hasStaticPermissionAnd = hasStaticPermissionAnd;
function hasStaticPermission(userPermissions, permission) {
    return userPermissions.indexOf(permission) !== -1;
}
exports.hasStaticPermission = hasStaticPermission;
async function evaluateDynamicPermissionOr(_id, roleDetails, userPermissions, dynamicPermissionParams) {
    if (dynamicPermissionParams && dynamicPermissionParams.length > 0) {
        let permissionDynamicParam;
        for (permissionDynamicParam of dynamicPermissionParams) {
            if (!hasStaticPermission(userPermissions, permissionDynamicParam.permission)) {
                continue;
            }
            if (await evaluateDynamicPermission(_id, roleDetails, userPermissions, permissionDynamicParam)) {
                return true;
            }
        }
    }
    return false;
}
exports.evaluateDynamicPermissionOr = evaluateDynamicPermissionOr;
async function evaluateDynamicPermission(_id, roleDetails, userPermissions, permissionDynamicParam) {
    if (!hasStaticPermission(userPermissions, permissionDynamicParam.permission)) {
        return false;
    }
    // TODO(mg): the goal is to have the authorization method sync.
    // In order to achieve that, we need to get rid of this promise for the args.
    // Instead pass the resolved argument directly
    const allArgs = await Promise.all(permissionDynamicParam.args.map(async (paramGetterOrPromise) => {
        if (typeof paramGetterOrPromise === "function") {
            return paramGetterOrPromise();
        }
        return paramGetterOrPromise;
    }));
    if (permissions_1.PermissionsDynamic[permissionDynamicParam.permission]({ uid: _id, roleDetails }, ...allArgs) === true) {
        return true;
    }
    return false;
}
exports.evaluateDynamicPermission = evaluateDynamicPermission;
function hasPermissionsSync(userJWT, staticPermissionParams) {
    if (!userJWT) {
        return false;
    }
    const { userId, roles } = userJWT;
    if (!roles || !roles.length || !userId) {
        return false;
    }
    const userPermissions = getPermissionsFromUserRoles(roles);
    // -- static evaluation --
    if (staticPermissionParams) {
        if (typeof staticPermissionParams === "string" &&
            hasStaticPermission(userPermissions, staticPermissionParams)) {
            return true;
        }
        if (staticPermissionParams.and &&
            hasStaticPermissionAnd(userPermissions, staticPermissionParams.and)) {
            return true;
        }
        if (staticPermissionParams.or &&
            hasStaticPermissionOr(userPermissions, staticPermissionParams.or)) {
            return true;
        }
    }
    return false;
}
exports.hasPermissionsSync = hasPermissionsSync;
async function hasPermissions(userJWT, staticPermissionParams, // having any of these permissions returns true
dynamicPermissionParams) {
    if (!userJWT) {
        return false;
    }
    const { userId, roles, roleDetails } = userJWT;
    if (!roles || !roles.length || !userId) {
        return false;
    }
    const userPermissions = getPermissionsFromUserRoles(roles);
    // -- static evaluation --
    if (staticPermissionParams) {
        const isAuthorizedByStaticPermissions = hasPermissionsSync(userJWT, staticPermissionParams);
        if (isAuthorizedByStaticPermissions) {
            return true;
        }
    }
    // -- dynamic evaluation --
    if (dynamicPermissionParams) {
        if (dynamicPermissionParams.args &&
            dynamicPermissionParams.permission &&
            (await evaluateDynamicPermission(userId, roleDetails, userPermissions, dynamicPermissionParams))) {
            return true;
        }
        if (dynamicPermissionParams.or &&
            (await evaluateDynamicPermissionOr(userId, roleDetails, userPermissions, dynamicPermissionParams.or))) {
            return true;
        }
    }
    return false;
}
exports.hasPermissions = hasPermissions;
//# sourceMappingURL=permissionsEvaluation.js.map